import { useNavigate } from "react-router-dom";
import Button from "../../UIComponent/UIbutton";

export default function HeroSection() {
  const navigate = useNavigate();
  return (
    <section className="relative  pb-[70px] w-full flex flex-col mt-[30px] items-center sm:mt-[35px] text-white overflow-hidden px-4 sm:px-8">
      {/* Headings */}

      <img
        src="/assets/img/Reviewwhite.png"
        className=" w-[294px] h-auto z-10 mb-[30px] sm:hidden"
        alt="Review"
      />

      <h1
        style={{ fontFamily: "myFirstFont" }}
        className=" text-[40px] mt-3 sm:text-[80px] text-center leading-[1] z-10"
      >
        Personal Loan <br /> Simplified
      </h1>

      <h3 className="text-[12px] sm:text-[24px] mt-3 text-center z-10">
        Give wings to your dreams. No collateral.
      </h3>

      {/* Button + Review */}
      <div className="flex flex-col sm:flex-row gap-4 mt-8 justify-center items-center z-10">
        <img
          src="/assets/img/Reviewwhite.png"
          className=" hidden  sm:block w-[294px] h-auto"
          alt="Review"
        />

        <Button
          height={"50px"}
          width={"250px"}
          className=" mt-2 sm:mt-0 flex justify-center items-center gap-1 text-sm sm:text-base"
          onClick={() => {
            window.open(
              "https://digitmoney.in/personal-loan-v13?aff_id=1&utm_term=&utm_medium=SMS",
              "_blank"
            );
          }}
        >
          Check Your Eligibility
          <img
            src="/assets/img/Layer_1 (10).png"
            className="h-[16px] w-[21px]"
            alt="Arrow"
          />
        </Button>
      </div>

      {/* Background Decorative Images (converted to % positions) */}
      <img
        src="/assets/img/6fdcd2efa6f5b6a0f82607d1a7abf7394ccde044.png"
        className=" hidden h-[100px] w-[100px] sm:block absolute  top-[-60px] left-[530px]  sm:h-[150px]  sm:w-[150px] lg:h-[225px] lg:w-[225px] sm:brightness-50 z-0"
        alt=""
      />
      <img
        src="/assets/img/6fdcd2efa6f5b6a0f82607d1a7abf7394ccde044.png"
        className="absolute top-[20%] left-[55%] h-[140px] w-[140px] brightness-75 sm:top-[-30px] sm:left-[764px] sm:h-[287px] sm:w-[287px] sm:brightness-[0.4] z-0"
        alt=""
      />
      <img
        src="/assets/img/6fdcd2efa6f5b6a0f82607d1a7abf7394ccde044.png"
        className="absolute top-[12%] left-[-5%] h-[269px] w-[269px] brightness-50 sm:top-[66px] sm:left-[334px] sm:h-[409px] sm:w-[409px] sm:brightness-[0.3] z-0"
        alt=""
      />
    </section>
  );
}
